import { initialState, setEditOutletDialog } from '../reducers/edit_outlet_dialog';
import { showDialog } from '../reducers/app';
export function newOutlet() {
    return (dispatch) => {
        dispatch(setEditOutletDialog(initialState));
        dispatch(showDialog('outlet-edit'));
    };
}
